<template>
  <div class="home-page"
    :class="($route.params ? $route.params.page : '', $route.name)"
    >
    <div class="[overlayMasterMenu ? 'master-menu-overlay' : null]">
      <SuperMenu
        :class="[overlayMasterMenu ? 'overlay-menu' : null]"
        :menuItems="rzLinks"
        :isRzWebsite="showRoanuzMenu"
        :showRoanuzSubMenu="showRoanuzSubMenu"
        v-if="rzLinks.length"/>
      <SuperMenu
        :class="[overlayMasterMenu ? 'overlay-menu' : null]"
        :menuItems="rzSubLinks"
        :sport="'cricket'"
        :isRzWebsite="showRoanuzMenu"
        v-if="rzSubLinks.length && showRoanuzSubMenu"/>
      <router-view class="flex-col"></router-view>
      <div class="home-footer-block" :class="[showRoanuzSubMenu ? 'have-submenu' : '']">
        <HomeFooter :showRzFooter="true" :showRoanuzSubMenu="showRoanuzSubMenu"/>
      </div>
      <!-- <div class="discount-promo" v-if="displayPromo && rsDiscountPromo">
        <DiscountPromo :rsDiscountPromo="rsDiscountPromo"
        :offerDate="rsDiscountPromo.links[0]" @hidePromo="hide()"/>
      </div> -->
    </div>
    <ConsentComponent :showCountdownPopup="showCountdownPopup"/>
    <CountdownPopup v-if="showCountdown && displayPromo" @hidePromo="hide()"/>
    <CountdownPopupBbl
      v-if="showRsCricketCountdownPopup"
      :endDate="rzPopup.links && rzPopup.links[2] ? rzPopup.links[2].desc : '2026-03-25T23:59:59'"
      :title="rzPopup.name || 'Indian Premier League  2026'"
      :subtitle="rzPopup.links && rzPopup.links[0] ? rzPopup.links[0].desc : 'is right around the corner!'"
      :subtitle2="rzPopup.links && rzPopup.links[1] ? rzPopup.links[1].desc : 'Countdown to Glory'"
      :ctaText="rzPopup.links && rzPopup.links[3] ? rzPopup.links[3].desc : 'Join the action'"
      :theme="'bbl-theme'"
      :redirectUrl="isOnCampaignPage ? null : rzPopup.links[3].url"
      @hidePromo="hideRsCricketCountdownPopup"
      @ctaClicked="handleRsCricketCountdownCTA"
    />
    <McpStickyBanner />
    <LandingSvg />
    <RzAllSvg />
  </div>
</template>

<style lang="scss">
.intercom-launcher,
.intercom-lightweight-app-launcher,
#intercom-container .intercom-launcher {
  bottom: size(90) !important;

  @media screen and (min-width: #{size(425)}) {
    bottom: size(80) !important;
  }
}

.home-page{
  --gray-line: #c4c4c4;

  --home-page-pad-top: #{size(20)};
  --home-page-pad-right: #{size(16)};
  --home-page-pad-left: #{size(0)};
  --home-page-pad-secondary-right: #{size(16)};

  --bottom-signup-font-size: #{size(24)};
  --bottom-signup-line-height: #{size(37)};

  @media screen and (min-width: $breakpoint-md) {
    --home-page-pad-top: #{size(56)};
    --home-page-pad-right: #{size(24)};
    --home-page-pad-left: #{size(28)};
    --home-page-pad-secondary-right: #{size(24)};

    --bottom-signup-font-size: #{size(36)};
    --bottom-signup-line-height: #{size(48)};
  }

  @media screen and (min-width: $breakpoint-lg) {
    --home-page-pad-top: #{size(54)};
    --home-page-pad-right: #{size(55)};
    --home-page-pad-left: #{size(46)};
    --home-page-pad-secondary-right: #{size(150)};

    --bottom-signup-font-size: #{size(40)};
    --bottom-signup-line-height: #{size(58)};
  }

  padding: 0 0;

  .content, .maxi-content {
    max-width: var(--home-page-content-max-width);
    margin: 0 auto;
  }

  .maxi-content {
    max-width: var(--home-page-header-max-width);
  }

  .rs-hero-title {
    font-size: var(--rs-title-level0-font-size);
    line-height: var(--rs-title-level0-line-height);
    font-weight: 800;
    color: var(--rs-black-color);
    font-family: var(--rz-hero-font);
    max-width: size(520);
    padding-bottom: size(40);
  }
  .rs-section-title {
    font-size: var(--rs-title-level4-font-size);
    line-height: var(--rs-title-level4-line-height);
    font-weight: bold;
    color: var(--rs-black-color);
    font-family: var(--rz-hero-font);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding-bottom: size(10);
  }
  .hero-title {
    font-size: var(--rs-title-hero-font-size);
    line-height: var(--rs-title-hero-line-height);
    font-weight: 800;
    color: var(--rs-black-color);
  }
  .rs-flex-box {
    display: flex;
    flex-wrap: wrap;
    &.space-between {
      justify-content: space-between;
    }
    &.align-center {
      align-items: center;
    }
    @media screen and (min-width: $breakpoint-md) {
      &.no-wrap {
        flex-wrap: initial;
      }
    }
  }
  .rs-sm-para {
    font-size: var(--rs-title-level5-font-size);
    line-height: var(--rs-title-level5-line-height);
    color: var(--rs-light-black-color);
    &.blue {
      color: var(--rs-cta-blue-color);
    }
    &.black {
      color: var(--rs-black-color);
    }
    &.bold {
      font-weight: bold;
    }
    &.semi-bold {
      font-weight: 500;
    }
  }

  .rs-md-para {
    font-size: var(--rs-md-label-font-size);
    line-height: var(--rs-md-label-line-height);
    &.blue {
      color: var(--rs-cta-blue-color);
    }
    &.black {
      color: var(--rs-black-color);
    }
    &.bold {
      font-weight: bold;
    }
    &.semi-bold {
      font-weight: 500;
    }
  }

  .rs-container {
    max-width: size(1080);
    margin: 0 auto;
    padding: size(50) size(20) size(10);
    .content-image-wrap {
      &.discount {
        padding-bottom: size(20);
        @media screen and (min-width: $breakpoint-lg) {
          padding-bottom: size(50);
        }
      }
    }
    &.pad-130 {
      padding-top: size(130);
    }
    &.pad-100 {
      padding-top: size(100);
    }
    &.get-started {
      &.pad-100 {
        padding-bottom: 0;
        padding-top: size(80);
        @media screen and (min-width: $breakpoint-md) {
          padding-top: size(120);
        }
        @media screen and (min-width: $breakpoint-lg) {
          padding-top: size(140);
        }
      }
    }
    @media screen and (min-width: $breakpoint-lg) {
      padding: size(50) 0;
    }
  }

  .rs-support-block {
    padding-top: size(70);
    .rs-container {
      position: relative;
    }
    @media screen and (min-width: $breakpoint-md) {
      padding-top: size(100);
    }
    @media screen and (min-width: $breakpoint-lg) {
      padding-top: size(120);
    }
  }

  .rs-resource-home {
    .pay-go-wrap {
      .flex-item {
        margin-right: 0;
      }
    }
  }

  .pay-go-wrap {
    color: var(--rs-black-color);
    &.featured-wrap {
      .flex-item {
        border-bottom: size(1) solid #424242;
        &.inner-box {
          &:first-child, &:nth-child(2) {
            padding-top: size(30);
          }
        }
      }
    }
    .flex-item.endpoint {
      margin-right: 0;
    }
    .auth-section {
      display: none;
    }
    .rs-container {
      padding-bottom: size(50);
      &.pad-10 {
        padding-top: size(20);
      }
    }
    svg {
      width: size(25);
      height: size(25);
    }
    .title {
      font-size: var(--rs-title-level2-font-size);
      line-height: var(--rs-title-level2-line-height);
      font-weight: bold;
      text-transform: capitalize;
      display: inline-block;
      color: var(--rs-black-color);
      padding: 0 size(30) size(10) 0;
      cursor: pointer;
      max-width: size(225);
      @media screen and (min-width: #{size(376)}) {
        max-width: size(300);
      }
      @media screen and (min-width: #{size(420)}) {
        max-width: unset;
      }
      @media screen and (min-width: $breakpoint-md) {
        display: inline-block;
      }
    }
    .endpoint {
      border-bottom: size(1) solid #C4C4C4;
    }
    .flex-item {
      padding-right: size(20);
      &-header, &.inner-box {
        padding-bottom: size(30);
        padding-top: size(30);
      }
      &.inner-box {
        &:first-child, &:nth-child(2) {
          padding-top: size(10);
        }
      }
      &-header {
        cursor: pointer;
        padding-top: size(25);
        padding-bottom: size(25);
        .flex-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .rs-flex-box {
        transition: height .6s cubic-bezier(.645,.045,.355,1), opacity .3s cubic-bezier(.645,.045,.355,1);
        opacity: 1;
        height: 0;
        overflow: hidden;
      }
      &.hide {
        .rs-flex-box {
          opacity: 0;
        }
        .expand {
          &:after {
            transform:rotate(90deg);
          }
          &:before {
            transform: initial;
          }
        }
      }
    }
    .end-point-link {
      font-size: var(--rs-title-level4-font-size);
      line-height: var(--rs-title-level4-line-height);
      color: var(--rs-cta-green-color);
      font-weight: bold;
      display: block;
      &.color-blue {
        color: var(--rs-cta-blue-color);
      }
    }
    .text {
      font-size: var(--rs-para-level0-font-size);
      line-height: var(--rs-para-level0-line-height);
      padding-top: size(10);
      display: inline-block;
    }
    .pricing-info {
      padding-top: size(30);
      @media screen and (min-width: $breakpoint-md) {
        padding-top: size(0);
      }
      .label {
        font-size: var(--rs-sm-label-font-size);
        line-height: var(--rs-sm-label-line-height);
        color: var(--rs-gray-color);
      }
    }
    .make-bold {
      font-size: var(--rs-title-level3-font-size);
      line-height: var(--rs-title-level3-line-height);
      font-weight: bold;
    }
    .flex-item {
        border-bottom: size(1) solid var(--rs-border-gray-color);
        padding-right: size(0);
        &:nth-child(1) {
          .flex-box-inner {
            border-top: none;
          }
        }
        &:nth-last-of-type(1) {
          border-bottom: none;
        }
        @media screen and (min-width: $breakpoint-lg) {
          margin-right: size(60);
          &:nth-child(2) {
            .flex-box-inner {
              border-top: none;
            }
          }
          &:nth-child(even) {
            margin-right: size(0);
          }
          &:nth-last-of-type(1), &:nth-last-of-type(2) {
              border-bottom: none;
              @media screen and (min-width: $breakpoint-md) {
                border-bottom: unset;
              }
            }
        }
        &.endpoint {
          border-bottom: size(1) solid #C4C4C4;
        }
        &.show-border {
          border-bottom: size(1) solid var(--rs-border-gray-color);
          padding-bottom: size(30);
        }
      }
      .flex-box-inner {
          display: flex;
          justify-content: space-between;
          width: 100%;
          flex-direction: column;
          @media screen and (min-width: $breakpoint-md) {
            flex-direction: row;
          }
          @media screen and (min-width: $breakpoint-lg) {
            // padding-top: size(30);
            &:nth-child(2) {
              border-top: none;
            }
            padding-top: size(0);
            width: size(510);
          }
          // .flex-item-rs {
            &:nth-child(1) {
              .block {
                padding-top: 0;
              }
            }
            .block {
              padding-bottom: size(40);
              padding-top: size(40);
              display: flex;
              border-bottom: size(1) solid var(--rs-border-gray-color);
              &-left {
                @media screen and (min-width: $breakpoint-md) {
                  padding-right: size(50);
                  flex: 0 0 74%;
                }
                @media screen and (min-width: $breakpoint-lg) {
                  flex: initial;
                }
              }
              &-right {
                padding-right: 0;
                @media screen and (min-width: $breakpoint-md) {
                  min-width: unset;
                  margin-left: auto;
                  align-self: flex-end;
                }
                @media screen and (min-width: $breakpoint-md) {
                  align-self: flex-start;
                  margin-top: size(35);
                }
                .tooltip {
                  font-size: size(12);
                  line-height: size(17);
                  a {
                    color: var(--rs-white-color);
                    font-weight: 600;
                    text-decoration: underline;
                    &:hover {
                      color: var(--rs-white-color);
                    }
                  }
                }
                .pricing-info {
                  .make-bold, .per-month, .label {
                    min-width: size(130);
                    text-align: left;
                    @media screen and (min-width: $breakpoint-md) {
                      text-align: right;
                    }
                  }
                  &.endpoints-section {
                    .tooltip {
                      a {
                        color: var(--regular-text);
                        font-weight: 600;
                        text-decoration: underline;
                        &:hover {
                          color: var(--regular-text);
                        }
                      }
                    }
                  }
                }
              }
            }
          // }
        }
    .featured-apis-wrap {
      background: var(--rs-black-color);
      color: var(--rs-white-color);
      .title {
        color: var(--rs-white-color);
      }
    }
    .expand {
      cursor: pointer;
      position:relative;
      padding: 0 size(10);
      width: size(16);
      height: size(16);
      background-color: transparent;
      border: 0;
      &:before, &:after {
        content: "";
        position: absolute;
        background-color: var(--rs-black-color);
        transition: transform 300ms cubic-bezier(.694,0,.335,1);
        width: size(2);
        height: size(16);
        top: 0;
      }
      &:after {
        transform: rotate(270deg);
      }
      &:before {
        transform: rotate(90deg);
      }
    }
    @media screen and (min-width: $breakpoint-md) {
      padding-bottom: size(50);
      &.featured-wrap {
        padding-bottom: size(0);
      }
      .flex-item {
        flex: 0 0 100%;
      }
    }
    @media screen and (min-width: $breakpoint-lg) {
      .flex-item {
        flex: 0 0 30%;
      }
    }
  }
  .strike-price {
    font-size: var(--rs-title-level5-font-size);
    line-height: var(--rs-title-level5-line-height);
    text-decoration: line-through;
    display: block;
    padding-bottom: size(4);
    font-weight: 500;
    &.inline {
      display: inline-block;
    }
  }

  .bottom-signup-block {
    @media screen and (min-width: $breakpoint-md) {
      padding-top: #{size(10)};
    }
    @media screen and (min-width: $breakpoint-lg) {
      padding-bottom: #{size(35)};
    }
    h3 {
      font-family: var(--hero-font);
      font-size: var(--bottom-signup-font-size);
      line-height: var(--bottom-signup-line-height);
      text-align: center;
      padding-left: size(32);
      padding-right: size(32);
      max-width: #{size(293)};
      margin: 0 auto;
      @media screen and (min-width: $breakpoint-md) {
        max-width: size(750);
      }
      @media screen and (min-width: $breakpoint-lg) {
        max-width: unset;
        margin: unset;
      }
    }
    .hero-links {
      display: flex;
      justify-content: center;
      padding: size(20) 0;
      @media screen and (min-width: $breakpoint-md) {
          padding: size(60) 0 0 0;
      }
      .btn {
        margin-right: size(11);
        border-width: 2px;
        border-color: var(--ca-btn-bg);
        text-transform: none;
        font-family: var(--regular-font);
        font-size: var(--banner-btn-font-size);
        font-weight: 600;
        line-height: var(--banner-btn-line-height);
        padding: size(10.5) size(16);
        letter-spacing: 0;
        @media screen and (min-width: $breakpoint-md) {
          padding: size(15) size(30);
        }
      }
      li {
        &:first-child .btn, &:not(:first-child) .btn:hover {
          background-color: var(--ca-btn-bg);
          color: var(--regular-text-inv);
        }
      }
    }
  }
  .content.placeholder {
    padding: size(30) size(10);
    max-width: var(--home-page-header-max-width);
  }
  .flex-col {
    min-height: size(700);
  }
  .blog-list, .article-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    color: var(--rs-black-color);
    .list-wrap {
      flex: 0 0 100%;
      padding-top: size(30);
      padding-bottom: size(30);
      border-bottom: size(1) dashed var(--rs-gray-color);
      @media screen and (min-width: $breakpoint-md) {
        flex-basis: 33%;
        .list {
          width: 90%;
        }
        &:nth-child(3n) {
          .list {
            float: right;
          }
        }
        &:nth-child(3n + 2) {
          .list {
            margin: auto;
          }
        }
      }
      img {
        border-radius: var(--rs-blog-border-radius);
        margin-bottom: size(18);
      }
      .image-wrap {
        margin-bottom: size(12);
      }
      .title {
        color: var(--rs-orange-color);
        padding-bottom: size(5);
        font-size: var(--rs-title-level5-font-size);
        line-height: var(--rs-title-level5-line-height);
        font-weight: bold;
      }
      .desc {
        padding-bottom: size(18);
        color: var(--regular-text);
        font-size: var(--rs-title-level4-font-size);
        line-height: var(--rs-title-level4-line-height);
      }
      .date {
        color: var(--rs-gray-color);
        font-size: var(--rs-sm-label-font-size);
        line-height: var(--rs-sm-label-line-height);
      }
      &.on-tab {
        display: none;
        @media screen and (min-width: $breakpoint-md) {
          display: block;
        }
      }
      a:hover {
        .desc {
          color: var(--rs-cta-blue-color);
        }
      }
      & {
        @include headerColorVariant(
          '.title',
          #b02907,
          #ff931e,
          #0751b9,
          #ba298a,
          #62cd9f,
          #856900
        );
      }
    }
    .image-item {
      transition: transform 0.5s;
      img {
        width: 100%;
        border-radius: var(--rs-blog-border-radius);
        margin: auto;
      }
      .show-container {
        text-align: left;
      }
    }
    .list-wrap:hover {
      .image-item {
        transform: scale(1.03);
      }
    }
    .list-wrap {
      .image-item {
        transform: scale(1);
      }
    }
    .image-wrap {
      position: relative;
      overflow: hidden;
      border-radius: var(--rs-blog-border-radius);
      height: size(210);
      img {
        object-fit: cover;
      }
    }
  }
}
</style>

<script>
import { mapState } from 'vuex';
import LandingSvg from '@/components/Svg/LandingSvg.vue';
import RzAllSvg from '@/components/Svg/RzAllSvg.vue';
import SuperMenu from '@/components/SportsHome/SuperMenu.vue';
// import DiscountPromo from '@/components/SportsHome/DiscountPromo.vue';
import HomeFooter from '@/components/SportsHome/HomeFooter.vue';
import moment from 'moment';
import CookieManager from '@/core/utils/cookieManager';
import ConsentComponent from './ConsentComponent.vue';
import CountdownPopup from '../../components/CountdownPopup.vue';
import CountdownPopupBbl from '../../components/CountdownPopupBbl.vue';
import McpStickyBanner from '../../components/McpStickyBanner.vue';

export default {
  components: {
    SuperMenu,
    HomeFooter,
    LandingSvg,
    RzAllSvg,
    // DiscountPromo,
    ConsentComponent,
    CountdownPopup,
    CountdownPopupBbl,
    McpStickyBanner,
  },
  data() {
    return {
      displayPromo: true,
      showCountdown: false,
      showRsCricketCountdownPopup: false,
    };
  },
  computed: {
    ...mapState({
      dataLoaded: (state) => state.page.activePageState.status.isLoaded,
      overlayMasterMenu: (state) => state.overlayMasterMenu,
      rzLinks: (state) => state.link.rzMenu.links,
      rzSubLinks: (state) => state.link.rzSubMenu.links,
      rsDiscountPromo: (state) => state.link.rsDiscountPromo,
      rzPopup: (state) => state.link.rzPopup,
    }),
    showRoanuzMenu() {
      return true;
    },
    showRoanuzSubMenu() {
      if (this.$router.currentRoute.matched.some((route) => (route.meta.pageType === 'rsCricketHome'))) {
        return true;
      }
      return false;
    },
    isOnCampaignPage() {
      return this.$route.name === 'rsCampaignPage';
    },
  },
  watch: {
    $route: function routeChanged() {
      // Re-check popup display when route changes
      this.$nextTick(() => {
        this.checkAndShowRsCricketPopup();
      });
    },
  },
  serverPrefetch() {
    return this.fetchData();
  },
  mounted() {
    if (!this.dataLoaded) {
      this.fetchData();
    }
    if (CookieManager.getItem('ipl2025-auction-2')) {
      this.displayPromo = false;
    }
    if (localStorage.getItem('rzConsent')) {
      this.showCountdown = true;
    }
    this.checkAndShowRsCricketPopup();
    window.addEventListener('rzConsentGiven', this.onConsentGiven);

    let urlParams;
    let utmSource = null;
    let utmId = null;

    try {
      urlParams = new URLSearchParams(window.location.search);
      utmSource = urlParams.get('utm_source');
      utmId = urlParams.get('utm_id');

      if ((!utmSource && window.location.search.includes('%3D'))
      || (!utmId && window.location.search.includes('%3D'))) {
        const decodedSearch = decodeURIComponent(window.location.search);
        urlParams = new URLSearchParams(decodedSearch);
        utmSource = urlParams.get('utm_source');
        utmId = urlParams.get('utm_id');
      }
    } catch (e) {
      console.error('Error parsing URL parameters:', e);
    }
    if (utmSource) {
      CookieManager.setItem('source_medium',
        utmSource, moment().add(30, 'day').toDate(), '/');
    }
    if (utmId) {
      CookieManager.setItem('source_id',
        utmId, moment().add(30, 'day').toDate(), '/');
    }
  },
  methods: {
    fetchData() {
      return this.$store.dispatch('link/fetchRzMenu').then(() => {
        return this.$store.dispatch('link/fetchRzSubMenu').then(() => {
          return this.$store.dispatch('link/fetchRsDiscountPromo').then(() => {
            return this.$store.dispatch('link/fetchPopup');
          });
        });
      });
    },
    hide() {
      this.displayPromo = false;
      const expires = moment().add(365, 'day');
      CookieManager.setItem('ipl2025-auction-2', false, expires.toDate(), '/');
    },
    showCountdownPopup() {
      this.showCountdown = true;
    },
    checkAndShowRsCricketPopup() {
      const hasSeenBBLPopup = localStorage.getItem('bbl-countdown-popup-seen');
      const hasConsent = localStorage.getItem('rzConsent');
      if (!hasSeenBBLPopup && hasConsent) {
        setTimeout(() => {
          this.showRsCricketCountdownPopup = true;
        }, 1000);
      }
    },
    onConsentGiven() {
      this.checkAndShowRsCricketPopup();
    },
    hideRsCricketCountdownPopup() {
      this.showRsCricketCountdownPopup = false;
      localStorage.setItem('bbl-countdown-popup-seen', 'true');
    },
    handleRsCricketCountdownCTA() {
      this.hideRsCricketCountdownPopup();
    },
  },
};
</script>
